import { ThemeInterface } from "../../../styles/theme";
const styles = (theme: ThemeInterface) => ({
	menuContainer: {
		padding: "5px 8px 5px 23px",
		marginLeft: "16px",
	},
	menuItem: {
		margin: "0px 16px",
	},
	primaryColor: {
		color: theme.palette.primary.main,
	},
});

export default styles;
